import {Component, Inject, OnInit} from "@angular/core";
import {ThemePalette} from "@angular/material/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {STEPPER_GLOBAL_OPTIONS} from "@angular/cdk/stepper";
import {MatStepper} from "@angular/material/stepper";
import {ContactService} from "../../../../portal/search-api/services/contact.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ContactPageRequestDto} from "../../../../portal/search-api/models/contact-page-request-dto";
import {GlobalSearchResultTypeEnum} from "../../../../portal/search-api/models/global-search-result-type-enum";
import {SurveyDto} from "../../../../portal/survey-api/models/survey-dto";
import {BudgetLimitEnum} from "../../../../portal/survey-api/models/budget-limit-enum";
import {SurveyMembershipTypeEnum} from "../../../../portal/survey-api/models/survey-membership-type-enum";
import {SolutionAimEnum} from "../../../../portal/survey-api/models/solution-aim-enum";
import {PeriodEnum} from "../../../../portal/survey-api/models/period-enum";
import {PersonReferenceDto} from "../../../../portal/survey-api/models/person-reference-dto";
import {SeatsAmountEnum} from "../../../../portal/survey-api/models/seats-amount-enum";
import {SurveyService} from "../../../../portal/survey-api/services/survey.service";



export interface KeyValuePair  {
  key: string;
  value: string;
}

export interface IQuestionModel {
  elementName:string
  title:string,
  elementValue: any[],
  elementSelectedValue: any[],
  elementCustomSpecify:string
}

export interface ISurveyModel{
  companyId:string,
  questions:IQuestionModel[]
}



@Component({
  selector: 'company-survey-dialog',
  templateUrl: './company-survey-dialog.component.html',
  styleUrls: ['./company-survey-dialog.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
})

export class CompanySurveyDialogComponent implements OnInit {

  survey = {
    elementsColor: "primary",
    progressValue: 0,
  }
  color: ThemePalette = 'primary';

  formGroup1: FormGroup;
  formGroup2: FormGroup;
  formGroup3: FormGroup;
  formGroup4: FormGroup;
  formGroup5: FormGroup;
  formGroup6: FormGroup;

  isVisibleCustomSpecify = false;
  isVisibleOther = false;
  isVisibleStep2 =false;
  companyId:string;
  surveyModel: ISurveyModel;
  surveyId:string;
  surveyDto:SurveyDto;

  startSelectedValuesAutocomplete1:KeyValuePair[];
  startSelectedValuesAutocomplete2:KeyValuePair[];
  startSelectedValuesAutocomplete3:KeyValuePair[];

  contacts:KeyValuePair[];
  contactsMaker:KeyValuePair[];
  category:KeyValuePair[];

  constructor(private _formBuilder: FormBuilder,
              private contactService:ContactService,
              private surveyService:SurveyService,
              public dialogRef: MatDialogRef<CompanySurveyDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data)
  {

    this.companyId = data.companyId;
    this.surveyId = data?.id;
    this.surveyModel = {
      companyId: this.companyId,
      questions:[
        {
          elementName:'radioGroup1',
          title:'For which Department is this project?',
          elementValue: ['Product', ' Engineering', 'CEO', 'Marketing', 'Design', 'Sales', 'Customer Success', 'Please specify'],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'radioGroup2',
          title:'Are you a member of this department?',
          elementValue: ['Yes', 'No'],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'radioGroup3',
          title:'How would you best characterize this project ?',
          elementValue: ['First time buying this product or service', 'Definitely replacing an existing solution', 'Considering replacing an existing solution'],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'radioGroup4',
          title:'What type of solution are you seeking?',
          elementValue: ['Software', 'Hardware', 'Services'],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'radioGroup5',
          title:'Is there a deadline established for a new solution to be in place?',
          elementValue: ['Yes', 'No'],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'radioGroup6',
          title:'What is the main reason for replacing this product or service?',
          elementValue: ['It didn\'t meet our needs', 'Looking for a better alternative','Looking for a cheaper alternative','Quality was less than expected','Ease of use was less than expected','Access to the service was less than expected','Customer service was less than expected','Other (describe)'],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'radioGroup7',
          title:'Is there a budget established for this project?',
          elementValue: ['Yes', 'No'],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName: 'chipsAutocomplete1',
          title: 'Which product category best describes your project?',
          elementValue: [
            "SALES",
            "CRM Software",
            "Sales Compensation Software",
            "AI Sales Assistant Software",
            "Auto Dialer Software",
            "Contract Analytics Software",
            "Contract Lifecycle Management (CLM) Software",
            "Contract Management Software",
            "Customer Revenue Optimization Software",
            "E-Signature Software",
            "Field Sales Software",
            "Other Sales Software",
            "Partner Management Software",
            "Quote Management Software",
            "CPQ Software",
            "Pricing Software",
            "Proposal Software",
            "Quote-to-Cash Software",
            "Visual Configuration Software",
            "Revenue Operations Software",
            "Sales Acceleration Software",
            "Conversation Intelligence Software",
            "Digital Sales Room Software",
            "Email Tracking Software",
            "Lead-to-Account Matching and Routing Software",
            "Outbound Call Tracking Software",
            "Sales Coaching Software",
            "Sales Enablement Software",
            "Sales Engagement Software",
            "Salesforce CRM Document Generation Software",
            "Sales Performance Management Software",
            "Sales Training and Onboarding Software",
            "Sales Acceleration Platforms Software",
            "Sales Analytics Software",
            "Sales Gamification Software",
            "Sales Intelligence Software",
            "Sales Platforms Software",
            "MARKETING",
            "Account-Based Marketing Software",
            "Account-Based Analytics Software",
            "Account-Based Data Software",
            "Buyer Intent Data Tools",
            "Marketing Account Intelligence Software",
            "Account-Based Execution Software",
            "Account-Based Advertising Software",
            "Account-Based Direct Mail Software",
            "Account-Based Web and Content Experiences Software",
            "Account-Based Orchestration Platforms Software",
            "Account Data Management Software",
            "Affiliate Marketing Software",
            "App Store Optimization Software",
            "Attribution Software",
            "Audience Intelligence Platforms",
            "B2B Services Review Platforms",
            "Blogger Outreach Software",
            "Book Marketing Tools Software",
            "Competitive Intelligence Tools Software",
            "Consumer Video Feedback Software",
            "Content Marketing Software",
            "Content Analytics Software",
            "Content Creation Software",
            "Content Curation Software",
            "Content Distribution Software",
            "Content Experience Platforms",
            "Conversational Marketing Software",
            "Conversion Rate Optimization Software",
            "A/B Testing Software",
            "Heat Maps Software",
            "Landing Page Builders",
            "Other Conversion Rate Optimization Software",
            "Product Analytics Software",
            "Session Replay Software",
            "Customer Data Platform (CDP) Software",
            "Customer Journey Analytics Software",
            "Customer Journey Mapping Software",
            "Customer-to-Customer (C2C) Community Marketing Software",
            "Demand Generation Software",
            "Brand Advocacy Software",
            "Customer Advocacy Software",
            "Employee Advocacy Software",
            "Lead Generation Software",
            "Lead Capture Software",
            "Lead Intelligence Software",
            "Lead Mining Software",
            "Lead Scoring Software",
            "Other Lead Generation Software",
            "Visitor Identification Software",
            "Loyalty Management Software",
            "Digital Analytics Software",
            "Digital Signage Software",
            "Direct Mail Automation Software",
            "Email Deliverability Software",
            "Email Marketing Software",
            "Email Signature Software",
            "Email Template Builder Software",
            "Email Testing Software",
            "Event Management Software",
            "Audience Response Software",
            "Conference Intelligence Software",
            "Event Management Platforms",
            "Event Marketing Software",
            "Event Planning Software",
            "Event Registration & Ticketing Software",
            "Lead Retrieval Software",
            "Mobile Event Apps",
            "Other Event Management Software",
            "Venue Management Software",
            "Virtual Event Platforms",
            "Gamification Software",
            "Inbound Call Tracking Software",
            "Local Marketing Software",
            "Local Listing Management Software",
            "Local SEO Software",
            "Store Locator Software",
            "Location-Based Marketing Software",
            "Marketing Analytics Software",
            "Marketing Automation Software",
            "Marketing Calendar Software",
            "Marketing Platforms Software",
            "Marketing Resource Management Software",
            "Market Intelligence Software",
            "Mobile Attribution Software",
            "Mobile Marketing Software",
            "Multi-level Marketing (MLM) Software",
            "Online Community Management Software",
            "Online Reputation Management Software",
            "Other Marketing Software",
            "Personalization Software",
            "Personalization Engines",
            "Pop-Up Builder Software",
            "Print Fulfillment Software",
            "Promotional Product Management Software",
            "Public Relations (PR) Software",
            "Media and Influencer Targeting Software",
            "Media Monitoring Software",
            "Other Public Relations Software",
            "PR Analytics Software",
            "PR CRM Software",
            "Press Release Distribution Software",
            "Push Notification Software",
            "Rewards and Incentives Software",
            "SEO Software",
            "Smart Link Software",
            "SMS Marketing Software",
            "Social Media Marketing Software",
            "Hashtag Monitoring Software",
            "Influencer Marketing Platforms",
            "Other Social Media Software",
            "Social Media Analytics Software",
            "Social Media Management Software",
            "Social Media Monitoring Software",
            "Social Media Suites",
            "Sweepstakes Software",
            "Tag Management Software",
            "Technology Research Services",
            "Technology Review Platforms",
            "Through-Channel Marketing Software",
            "Transactional Email Software",
            "URL Shortener",
            "User Research Software",
            "Webinar Software",
            "ANALYTICS    ",
            "Analytics Platforms Software",
            "Business Intelligence Software",
            "Data Visualization Software",
            "Embedded Business Intelligence Software",
            "Location Intelligence Software",
            "Data Virtualization Software",
            "Enterprise Drone Analytics Software",
            "Enterprise Search Software",
            "Insight Engines Software",
            "Other Analytics Software",
            "Predictive Analytics Software",
            "Statistical Analysis Software",
            "Text Analysis Software",
            "Time Series Intelligence Software",
            "Visitor Behavior Intelligence Software",
            "ARTIFICIAL INTELLIGENCE",
            "AI & Machine Learning Operationalization Software",
            "Conversational Intelligence Software",
            "Bot Platforms Software",
            "Chatbots Software",
            "Intelligent Virtual Assistants Software",
            "Natural Language Processing (NLP) Software",
            "Natural Language Generation (NLG) Software",
            "Natural Language Understanding (NLU) Software",
            "Text to Speech Software",
            "Data Labeling Software",
            "Data Science and Machine Learning Platforms",
            "Deep Learning Software",
            "Artificial Neural Network Software",
            "Image Recognition Software",
            "Voice Recognition Software",
            "Machine Learning Software",
            "Machine Learning Operationalization Software",
            "Synthetic Data Software",
            "B2B MARKETPLACE",
            "Merchant Marketing Software",
            "On-Demand Delivery Software",
            "Grocery Delivery Software",
            "On-Demand Catering Software",
            "Restaurant Delivery/Takeout Software",
            "On-Demand Wellness Software",
            "Ride Sharing Software",
            "CAD & PLM",
            "3D Printing Software",
            "BIM Objects Software",
            "CAD Software",
            "Building Design and Building Information Modeling (BIM) Software",
            "CAD Data Exchange Software",
            "CAD Libraries Software",
            "CAD Viewers Software",
            "Civil Engineering Design Software",
            "General-Purpose CAD Software",
            "MEP Software",
            "Other CAD Software",
            "PCB Design Software",
            "Product and Machine Design Software",
            "Sketching Software",
            "Computer-Aided Manufacturing Software",
            "GIS Software",
            "Photogrammetry Software",
            "PLM Software",
            "Product Data Management (PDM) Software",
            "Simulation & CAE Software",
            "Urban Planning and Design Software",
            "COLLABORATION AND PRODUCTIVITY",
            "Team Collaboration Software",
            "Collaborative Whiteboard Software",
            "Employee Intranet Software",
            "Screen Sharing Software",
            "Virtual Workspaces Software",
            "Visual Collaboration Platforms Software",
            "Other Collaboration Software",
            "Audio Conferencing Software",
            "Board Management Software",
            "Decision-Making Software",
            "Digital Adoption Platform Software",
            "Google Workspace Marketplace Software",
            "Google Workspace Business Tools",
            "Google Workspace Administration Software",
            "Google Workspace ERP Software",
            "Google Workspace for Finance Software",
            "Google Workspace for HR Software",
            "Google Workspace for Marketing Software",
            "Google Workspace for Sales Software",
            "Google Workspace Communication Tools",
            "Google Workspace Education Software",
            "Google Workspace Academic Software",
            "Google Workspace Teacher Resources Software",
            "Google Workspace Productivity Tools",
            "Google Workspace Creative Tools",
            "Google Workspace Development Tools",
            "Google Workspace Office Tools",
            "Google Workspace Project Management Software",
            "Google Workspace Utilities Software",
            "Idea Management Software",
            "Internal Communications Software",
            "Business Instant Messaging Software",
            "Employee Communications Software",
            "Meeting Management Software",
            "Mind Mapping Software",
            "Note-Taking Management Software",
            "Objectives and Key Results (OKR) Software",
            "Productivity Bots Software",
            "Push-To-Talk (PTT) Software",
            "Room Systems",
            "Shared Inbox Software",
            "Social Networks Software",
            "Transcription Software",
            "UCaaS Platforms",
            "Unified Workspaces Software",
            "Video Conferencing Software",
            "VoIP Providers",
            "COMMERCE",
            "E-Commerce Software",
            "Catalog Management Software",
            "E-Commerce Platforms",
            "E-Commerce Tools",
            "E-commerce Fraud Protection Software",
            "E-Merchandising Software",
            "Multichannel Retail Software",
            "Product Reviews Software",
            "Subscription Management Software",
            "Age Verification Software",
            "Brand Protection Software",
            "Drop Shipping Software",
            "E-Commerce Analytics Software",
            "E-Commerce Personalization Software",
            "E-Commerce Search Software",
            "Marketplace Software",
            "Mobile E-Commerce Software",
            "Online Marketplace Optimization Tools",
            "Print On Demand Software",
            "Product Information Management (PIM) Software",
            "Shopping Cart Software",
            "Subscription Analytics Software",
            "Subscription Billing Software",
            "Subscription Revenue Management Software",
            "Virtual Fitting Software",
            "Visual Product Customization Software",
            "Omnichannel Commerce Software",
            "Payment Software",
            "Payment Gateways",
            "Installment Payment Software",
            "Payment Analytics Software",
            "Payment Card Issuance Software",
            "Payment Processing Software",
            "POS Software",
            "Restaurant POS Systems",
            "Retail POS Systems",
            "Retail Software",
            "Automotive Retail Software",
            "Other Retail Software",
            "Retail Analytics Software",
            "Retail Assortment Management Applications Software",
            "Retail Business Management Software",
            "Retail Distributed Order Management Systems",
            "Retail Execution Software",
            "Retail Intelligence Software",
            "Retail IoT Software",
            "Retail Management Systems",
            "Retail Operations Software",
            "Retail Pricing Software",
            "Retail Space Planning Software",
            "Retail Task Management Software",
            "Trade Promotion Management Software",
            "CONTENT MANAGEMENT",
            "Client Portal Software",
            "Cloud Content Collaboration Software",
            "CMS Tools",
            "Commenting Systems",
            "Component Content Management Systems",
            "Desktop Search Software",
            "Digital Accessibility Software",
            "Website Accessibility Software",
            "Website Accessibility Plugins Software",
            "Digital Accessibility Platforms",
            "Digital Accessibility Tools",
            "Digital Asset Management Software",
            "Digital Experience Platforms (DXP) Software",
            "Digital Rights Management (DRM) Software",
            "Enterprise Content Management (ECM) Software",
            "File Migration Software",
            "Headless CMS Software",
            "Image Optimization Software",
            "Knowledge Management Software",
            "Enterprise Wiki Software",
            "Q&A Platforms",
            "Standard Operating Procedures Software",
            "Work Instructions Software",
            "Live Blog Software",
            "Localization Software",
            "Computer-Assisted Translation Software",
            "Machine Translation Software",
            "Other Translation Software",
            "Translation Management Software",
            "Website Translation Tools",
            "Mobile Forms Automation Software",
            "OCR Software",
            "Online Form Builder Software",
            "Online Proofing Software",
            "User-Generated Content Software",
            "Video CMS Software",
            "Virtual Data Room Software",
            "Web Content Management Software",
            "Website Builder Software",
            "Website Screenshot Software",
            "WordPress Site Management Software",
            "CUSTOMER SERVICE",
            "Help Desk Software",
            "Live Chat Software",
            "Customer Self-Service Software",
            "Social Customer Service Software",
            "Appointment Reminder Software",
            "Co-Browsing Software",
            "Complaint Management Software",
            "Contact Center Software",
            "Contact Center Knowledge Base Software",
            "Contact Center Operations Software",
            "Contact Center Quality Assurance Software",
            "Contact Center Workforce Software",
            "Speech Analytics Software",
            "Telecom Services for Call Centers Software",
            "Conversational Support Software",
            "Customer Communications Management Software",
            "Customer Education Software",
            "Customer Success Software",
            "Digital Customer Service Platforms Software",
            "Employee Monitoring Software",
            "Enterprise Feedback Management Software",
            "Experience Management Software",
            "Feedback Analytics Software",
            "Field Service Management Software",
            "Other Customer Service Software",
            "Proactive Notification Software",
            "Telecommunications Retail Management System",
            "DATA PRIVACY    ",
            "Consent Management Platform (CMP) Software",
            "Cookie and Website Tracker Scanning Software",
            "Data Breach Notification Software",
            "Data De-identification and Pseudonymity Software",
            "Data Privacy Management Software",
            "Data Subject Access Request (DSAR) Software",
            "Identity Verification Software",
            "Other Privacy Software",
            "Privacy Impact Assessment (PIA) Software",
            "Privacy Policy Generator Software",
            "Sensitive Data Discovery Software",
            "DESIGN",
            "Virtual Tour Software",
            "3D Design Software",
            "3D Modeling Software",
            "3D Painting Software",
            "3D Rendering Software",
            "Audio Editing Software",
            "Creative Portfolio Management Software",
            "Diagramming Software",
            "Display Ad Design Software",
            "Font Management Software",
            "Graphic Design Software",
            "Desktop Publishing Software",
            "Drawing Software",
            "Flipbook Software",
            "Vector Graphics Software",
            "Other Design Software",
            "Photography Software",
            "Photo Editing Software",
            "Photo Management Software",
            "Podcast Hosting Software",
            "Software Design Software",
            "Prototyping Software",
            "Software Design Platforms Software",
            "Web Design Software",
            "Wireframing Software",
            "Stock Media Software",
            "Stock Footage Software",
            "Stock Music Software",
            "Stock Photos Websites",
            "Video Software",
            "Animation Software",
            "Live Stream Software",
            "Live Stream Broadcasting Software",
            "Other Video Software",
            "OTT Platforms Software",
            "Video Editing Software",
            "Video Effects Software",
            "Video Email Software",
            "Video Hosting Software",
            "Web Font Marketplace Software",
            "DEVELOPMENT      ",
            "Cloud Platform as a Service (PaaS) Software",
            "Integrated Development Environments (IDE)",
            "C/C++ Integrated Development Environments (IDE)",
            "Java Integrated Development Environments (IDE)",
            ".NET Integrated Development Environments (IDE)",
            "Other Integrated Development Environments (IDE)",
            "PHP Integrated Development Environments (IDE)",
            "Python Integrated Development Environments (IDE)",
            "Software Testing Tools",
            "Help Authoring Tool (HAT) Software",
            "Other Development Software",
            "API Design Software",
            "API Management Software",
            "API Marketplace Software",
            "Application Development Software",
            "ALM Suites Software",
            "Application Development Platforms",
            "Mobile Development Software",
            "Mobile Development Platforms Software",
            "Drag and Drop App Builder Software",
            "Mobile Development Frameworks Software",
            "Mobile Backend-as-a-Service (mBaaS) Software",
            "Mobile App Debugging Software",
            "Mobile App Testing Software",
            "Cloud Communication Platforms",
            "Enterprise App Store Software",
            "Mobile Analytics Software",
            "Mobile App Analytics",
            "Mobile Crash Reporting Software",
            "Mobile App Optimization Software",
            "Other Mobile Development Software",
            "Rapid Application Development (RAD) Software",
            "Low-Code Development Platforms",
            "No-Code Development Platforms Software",
            "Workplace Innovation Platforms",
            "Component Libraries Software",
            "Continuous Testing Platforms Software",
            "Crowdsourced Testing Software",
            "Development Analytics Tools",
            "DevOps Software",
            "Bug Tracking Software",
            "Application Release Orchestration Software",
            "Batch Management Software",
            "CI/CD Tools",
            "Continuous Delivery Software",
            "Continuous Integration Tools",
            "Build Automation Software",
            "Configuration Management Software",
            "Other Continuous Delivery Software",
            "Cloud Infrastructure Automation Software",
            "Containerization Software",
            "Container Engine Software",
            "Container Management Software",
            "Container Monitoring Software",
            "Container Networking Software",
            "Container Orchestration Software",
            "Container Registry Software",
            "Runtime Software",
            "Service Discovery Software",
            "DevOps Platforms Software",
            "Source Code Management Software",
            "Version Control Systems",
            "Peer Code Review Software",
            "Version Control Clients Software",
            "Version Control Hosting Software",
            "Test Automation Software",
            "Value Stream Management Software",
            "Editor Software",
            "Text Editor",
            "WYSIWYG Editors Software",
            "Feature Management Software",
            "Game Development Software",
            "Audio Engine Software",
            "Game Engine Software",
            "Gaming Tools",
            "Physics Engine Software",
            "Geofencing Software",
            "Load Testing Software",
            "Portals Software",
            "Product Management Software",
            "Repository Management Software",
            "Requirements Management Software",
            "Software Localization Tools",
            "Test Management Software",
            "User Research Repositories Software",
            "Video Platform as a Service (VPaaS) Software",
            "Web Frameworks Software",
            "Other Web Frameworks Software",
            "JavaScript Web Frameworks Software",
            "Java Web Frameworks Software",
            "PHP Web Frameworks Software",
            "Python Web Frameworks Software",
            "WebOps Platforms",
            "DIGITAL ADVERTISING",
            "Ad Network Software",
            "Advertiser Campaign Management Software",
            "Creative Management Platforms",
            "Cross-Channel Advertising Software",
            "Demand Side Platform (DSP)",
            "Digital Audio Advertising Software",
            "Display Advertising Software",
            "Mobile Advertising Software",
            "Native Advertising Software",
            "Search Advertising Software",
            "Social Media Advertising Software",
            "Video Advertising Software",
            "Click Fraud Software",
            "Data Management Platform (DMP) Software",
            "Digital Ad Intelligence Software",
            "Identity Resolution Software",
            "Other Digital Advertising Software",
            "Paid Search Intelligence Software",
            "Publisher Ad Management Software",
            "App Monetization Software",
            "Other Publisher Management Software",
            "Publisher Ad Server Software",
            "Search Monetization Software",
            "Supply Side Platform (SSP) Software",
            "Retail Media Advertising Platforms",
            "Retargeting Software",
            "ERP",
            "Procurement Software",
            "AP and Spend Analysis Software",
            "Procure to Pay Software",
            "Purchasing Software",
            "RFP Software",
            "Spend Management Software",
            "Strategic Sourcing Software",
            "Vendor Management Software",
            "3D Parts Catalogs Software",
            "Accounting & Finance Software",
            "Order Management Software",
            "Accounting Software",
            "Accounting Practice Management Software",
            "AP Automation Software",
            "AR Automation Software",
            "Billing Software",
            "Budgeting and Forecasting Software",
            "Cash Flow Management Software",
            "Corporate Performance Management (CPM) Software",
            "Corporate Tax Software",
            "Credit and Collections Software",
            "Enterprise Payment Software",
            "Financial Analysis Software",
            "Financial Audit Software",
            "Financial Close Software",
            "Foreign Exchange Software",
            "Invoice Management Software",
            "Other Finance & Admin. Software",
            "Remittance & Money Transfer Software",
            "Revenue Management Software",
            "Sales Tax and VAT Compliance Software",
            "Travel & Expense Software",
            "Travel Management Software",
            "Expense Management Software",
            "Mileage Tracking Software",
            "Treasury Management Software",
            "Advanced Planning and Scheduling (APS) Software",
            "Asset Management Software",
            "Facility Management Software",
            "Asset Leasing Software",
            "Asset Performance Management Software",
            "Asset Tracking Software",
            "Calibration Software",
            "CMMS Software",
            "Enterprise Asset Management (EAM) Software",
            "Predictive Maintenance Software",
            "Tool Tracking Software",
            "Business Activity Monitoring Software",
            "Business Plan Software",
            "Discrete ERP Software",
            "Distribution ERP Software",
            "Document Generation Software",
            "Environmental, Quality and Safety Management Software",
            "Environmental Health and Safety Software",
            "Occupational Health and Safety (OHS) Software",
            "Quality Management (QMS)",
            "Specification Management Software",
            "Equity Management Software",
            "ERP Systems",
            "ETO ERP Software",
            "Industrial IoT Software",
            "Job Shop Management Software",
            "Manufacturing Execution System",
            "Manufacturing Intelligence Software",
            "Mixed Mode ERP Software",
            "Process ERP Software",
            "Professional Services Automation Software",
            "Project-Based ERP Software",
            "Project, Portfolio & Program Management Software",
            "Capital Project Management Software",
            "Client Onboarding Software",
            "Earned Value Management Software",
            "Kanban Project Management Software",
            "Project and Portfolio Management Software",
            "Project Collaboration Software",
            "Project Cost Management Software",
            "Project Management Software",
            "Project Management Tools Software",
            "Resource Management Software",
            "Strategic Planning Software",
            "Task Management Software",
            "Work Management Software",
            "Smart Buildings Software",
            "Strategy and Innovation Roadmapping Tools Software",
            "Supervisory Control and Data Acquisition (SCADA) Software",
            "Systems Engineering & MBSE Software",
            "Tools for ERP Software",
            "Warranty Management Software",
            "GOVERNANCE, RISK & COMPLIANCE",
            "Anti Money Laundering Software",
            "Audit Management Software",
            "Business Continuity Management Software",
            "Call Compliance Software",
            "Corporate Entity Management Software",
            "Disclosure Management Software",
            "Ethics and Compliance Learning Software",
            "GRC Platforms",
            "GRC Tools",
            "Investigation Management Software",
            "Operational Risk Management Software",
            "Policy Management Software",
            "Regulatory Change Management Software",
            "Third Party & Supplier Risk Management Software",
            "HOSTING",
            "Content Delivery Network (CDN) Software",
            "Domain Registration Providers",
            "Enterprise Content Delivery Network (eCDN) Software",
            "Managed DNS Providers Software",
            "Managed Hosting Providers",
            "Other Hosting Services Providers",
            "Virtual Private Servers (VPS) Providers",
            "Web Hosting Providers",
            "HR",
            "HRMS & HCM Software",
            "Talent Management Software",
            "Recruiting Software",
            "Talent Acquisition Suites Software",
            "Recruitment Marketing Platforms",
            "Applicant Tracking Systems",
            "Onboarding Software",
            "Recruitment Platforms Software",
            "Video Interviewing Software",
            "Pre-Employment Screening Software",
            "Pre-Employment Testing Software",
            "Reference Check Software",
            "Background Check Software",
            "Drug Testing Software",
            "Technical Skills Screening Software",
            "Other Recruiting Software",
            "Candidate Relationship Management Software",
            "Diversity Recruiting Software",
            "Employee Referral Software",
            "Interview Scheduling Software",
            "Job Description Management Software",
            "Job Search Sites",
            "Programmatic Job Advertising Software",
            "Recruiting Automation Software",
            "Virtual Career Fair Platforms",
            "Training eLearning Software",
            "Corporate Learning Management Systems",
            "Course Authoring Software",
            "Digital Credential Management Software",
            "eLearning Content Software",
            "Harassment Prevention Training Software",
            "Learning Experience Platforms (LXP)",
            "Mentoring Software",
            "Microlearning Platforms",
            "Training Management Systems",
            "Performance Management Systems",
            "Employee Engagement Software",
            "Compensation Management Software",
            "Career Management Software",
            "Employee Recognition Software",
            "Exit Interview Management Software",
            "Offboarding Software",
            "Relocation Management Software",
            "Skills Management Software",
            "Succession Planning and Management Software",
            "Talent Intelligence Software",
            "Core HR Software",
            "Benefits Administration Software",
            "Workforce Management Software",
            "Time Tracking Software",
            "Freelance Platforms",
            "Staffing Software",
            "Other HR Software",
            "401(k) Software",
            "Absence Management Software",
            "Benefits Support Software",
            "Contractor Management Software",
            "Corporate Social Responsibility (CSR) Software",
            "Corporate Volunteering Platforms",
            "Corporate Wellness Software",
            "Earned Wage Access Software",
            "Employee Identity Theft Protection Software",
            "Employee Scheduling Software",
            "Financial Wellness Software",
            "Freelancer Management Systems",
            "HR Analytics Software",
            "HR Case Management Software",
            "HR Compliance Software",
            "HR Service Delivery Software",
            "Job Board Software",
            "Multi-Country Payroll Software",
            "Payroll Software",
            "PEO Providers",
            "Time & Attendance Software",
            "Whistleblowing Software",
            "IOT MANAGEMENT",
            "Connected Worker Platforms",
            "Digital Twin Software",
            "IoT Analytics Software",
            "IoT Connectivity Management Software",
            "IoT Development Tools",
            "IoT Device Management Software",
            "IoT Edge Platforms Software",
            "IoT Operating Systems",
            "IoT Platforms",
            "Other IoT Software",
            "IT INFRASTRUCTURE",
            "Infrastructure as a Service (IaaS) Providers",
            "Address Verification Software",
            "AIOps Platforms Software",
            "Application Server Software",
            "Blockchain Software",
            "Asset Tokenization Platforms",
            "Blockchain Analysis Software",
            "Blockchain as a Service Software",
            "Blockchain Payments Software",
            "Blockchain Platforms Software",
            "Blockchain Security Software",
            "Cryptocurrency Software",
            "Cryptocurrency Custody Software",
            "Cryptocurrency Exchanges",
            "Cryptocurrency Mining Software",
            "Cryptocurrency Payment Apps",
            "Cryptocurrency Remittance Software",
            "Cryptocurrency Wallets",
            "Smart Contracts Software",
            "Cloud Computing Platforms Software",
            "Cloud File Storage Software",
            "Database Software",
            "Relational Databases Software",
            "NoSQL Databases Software",
            "Document Databases Software",
            "Graph Databases",
            "Key Value Databases",
            "Object-Oriented Databases Software",
            "Other Non-Relational Databases Software",
            "RDF Databases Software",
            "XML Databases Software",
            "Database Management Systems (DBMS) Software",
            "Big Data Software",
            "Big Data Analytics Software",
            "Big Data Processing and Distribution Software",
            "Event Stream Processing Software",
            "Database as a Service (DBaaS) Provider",
            "Database Comparison Software",
            "Desktop Database Software",
            "Structured Data Archiving and Application Retirement Software",
            "Time Series Databases Software",
            "Data Center Infrastructure Management (DCIM) Software",
            "Data Center Networking Software",
            "Data Exchange Software",
            "Data Fabric Software",
            "Data Integration Software",
            "Cloud Data Integration Software",
            "Big Data Integration Platform",
            "Cloud Migration Software",
            "Enterprise Service Bus (ESB) Software",
            "ETL Tools",
            "Hybrid Integration Platform (HIP) Software",
            "iPaaS Software",
            "Other Cloud Integration Software",
            "Stream Analytics Software",
            "E-Commerce Data Integration Software",
            "Electronic Data Interchange (EDI) Software",
            "File Transfer Protocol (FTP) Software",
            "Integration Brokerage Software",
            "Managed File Transfer (MFT) Software",
            "On-Premise Data Integration Software",
            "Data Management Platforms Software",
            "Data Mapping Software",
            "DataOps Platforms",
            "Data Preparation Software",
            "Data Quality Software",
            "Data Warehouse Software",
            "Data Warehouse Automation Software",
            "Desktop as a Service (DaaS) Providers",
            "Guest Wi-Fi Providers",
            "Hyperconverged Infrastructure (HCI) Solutions",
            "Load Balancing",
            "Machine Learning Data Catalog Software",
            "Managed Workplace Services (MWS) Software",
            "Master Data Management (MDM) Software",
            "Monitoring Software",
            "Application Performance Monitoring (APM) Software",
            "Cloud Infrastructure Monitoring Software",
            "Database Monitoring Software",
            "Enterprise Monitoring Software",
            "Hardware Monitoring Software",
            "Log Monitoring Software",
            "Network Monitoring Software",
            "Observability Solution Suites Software",
            "Other Monitoring Software",
            "Website Monitoring Software",
            "Network Management Software",
            "Operating Systems",
            "Other IT Infrastructure Software",
            "Remote Desktop Software",
            "Remote Support Software",
            "Server Monitoring Software",
            "Server Virtualization Software",
            "Storage Management Software",
            "Archive Storage Software",
            "Block Storage Software",
            "Hybrid Cloud Storage Software",
            "Object Storage Software",
            "VDI",
            "Virtual Private Cloud (VPC) Software",
            "Virtual Routers",
            "WAN Edge Infrastructure Software",
            "WAN Optimization Software",
            "Web Accelerator Software",
            "Web Client Accelerator Software",
            "Web Server Accelerator Software",
            "IT MANAGEMENT",
            "Application Portfolio Management Software",
            "Cloud Cost Management Software",
            "Cloud Management Platforms",
            "Cloud Migration Assessment Tools",
            "Columnar Databases Software",
            "Data Destruction Software",
            "Data Extraction Software",
            "Data Governance Software",
            "Data Recovery Software",
            "Disaster Recovery as a Service (DRaaS) Software",
            "Backup Software",
            "Database Backup Software",
            "Data Replication Software",
            "File Recovery Software",
            "Hard Drive Cloning Software",
            "Online Backup Software",
            "PC Backup Software",
            "SaaS Backup Software",
            "Server Backup Software",
            "Backup Solution Suites Software",
            "Disaster Recovery Software",
            "Email Archiving Software",
            "Digital Employee Experience (DEX) Management Software",
            "Digital Experience Monitoring (DEM) Software",
            "Digital Governance Software",
            "Disk Cleanup Software",
            "Enterprise Architecture Software",
            "Enterprise Information Archiving Software",
            "Enterprise IT Management Suites Software",
            "Enterprise Mobility Management Software",
            "File Analysis Software",
            "Hard Drive Partitioning Software",
            "Incident Management Software",
            "Information Stewardship Applications Software",
            "IT Alerting Software",
            "IT Asset Management Software",
            "IT Process Automation Software",
            "IT Resilience Orchestration Automation (ITRO) Software",
            "IT Service Management Tools",
            "Message Queue (MQ) Software",
            "Mobile Application Management Software",
            "Mobile Device Management (MDM) Software",
            "Network Automation Software",
            "Office 365 Management Software",
            "OS Imaging & Deployment Software",
            "Other IT Management Software",
            "Process Automation Software",
            "Business Process Management Software",
            "Business Process Simulation Software",
            "Decision Management Platforms Software",
            "Digital Process Automation (DPA) Software",
            "Other Process Automation Software",
            "Process Mining Software",
            "Robotic Process Automation (RPA) Software",
            "Workflow Management Software",
            "Remote Monitoring & Management (RMM) Software",
            "SaaS Operations Management Software",
            "SaaS Spend Management Software",
            "SD-WAN Software",
            "Service Desk Software",
            "Software Asset Management (SAM) Software",
            "Technology Scouting Software",
            "Telecom Expense Management (TEM) Services Software",
            "Terminal Emulator Software",
            "Unified Endpoint Management (UEM) Software",
            "Virtual IT Labs Software",
            "Virtual Waiting Room Software",
            "Workload Automation Software",
            "MISCELLANEOUS OFFICE SOFTWARE",
            "Bookmark Manager Software",
            "Browser Software",
            "Business Card Scanning Software",
            "Business Music Software",
            "Calendar Software",
            "Digital Wayfinding Software",
            "Document Creation Software",
            "Document Scanning Software",
            "Email Software",
            "Email Client Software",
            "Email Verification Software",
            "Emergency Notification Software",
            "File Converter Software",
            "File Reader Software",
            "Handwritten Notes Software",
            "Lost and Found Software",
            "Meeting Room Booking Systems",
            "Office Suites Software",
            "Online Appointment Scheduling Software",
            "Online Fax Software",
            "Org Chart Software",
            "Package Tracking Software",
            "PDF Editor Software",
            "Presentation Software",
            "Print Management",
            "Queue Management Software",
            "Screen and Video Capture Software",
            "Screenwriting Software",
            "Space Management Software",
            "Survey Software",
            "Virtual Mailbox Software",
            "Visitor Management Software",
            "Writing Assistants Software",
            "AI Writing Assistant Software",
            "Plagiarism Checker Software",
            "Proofreading Software",
            "SECURITY",
            "Cloud Security Software",
            "API Security Software",
            "Cloud Access Security Broker (CASB) Software",
            "Cloud Compliance Software",
            "Cloud Data Security Software",
            "Cloud DDoS Mitigation Software",
            "Cloud Edge Security Software",
            "Cloud File Security Software",
            "Cloud Security Monitoring and Analytics Software",
            "Cloud Security Posture Management (CSPM) Software",
            "Cloud Workload Protection Platforms Software",
            "Extended Detection and Response (XDR) Platforms Software",
            "Service Mesh Tools Software",
            "System Security Software",
            "Incident Response Software",
            "Security Information and Event Management (SIEM) Software",
            "Threat Intelligence Software",
            "Breach and Attack Simulation (BAS) Software",
            "Deception Technology Software",
            "Digital Forensics Software",
            "IoT Security Software",
            "Malware Analysis Tools Software",
            "Managed Detection and Response (MDR) Software",
            "Security Orchestration, Automation, and Response (SOAR) Software",
            "Application Security Software",
            "Application Shielding Software",
            "Runtime Application Self-Protection (RASP) Software",
            "Confidentiality Software",
            "Encryption Software",
            "Certificate Lifecycle Management (CLM) Software",
            "DMARC Software",
            "Proxy Network Software",
            "SSL & TLS Certificates Software",
            "Data Security Software",
            "Database Security Software",
            "Data Center Security Software",
            "Data-Centric Security Software",
            "Data Loss Prevention (DLP) Software",
            "Data Masking Software",
            "Encryption Key Management Software",
            "Mobile Data Security Software",
            "DevSecOps Software",
            "Static Code Analysis Software",
            "Container Security Software",
            "Dynamic Application Security Testing (DAST) Software",
            "Log Analysis Software",
            "Penetration Testing Software",
            "Secure Code Review Software",
            "Software Composition Analysis Software",
            "Static Application Security Testing (SAST) Software",
            "Vulnerability Scanner Software",
            "Web Application Firewall (WAF) Software",
            "Email Security Software",
            "Secure Email Gateway Software",
            "Cloud Email Security Software",
            "Email Anti-spam Software",
            "Email Encryption Software",
            "Intelligent Email Protection Software",
            "Endpoint Protection Software",
            "Antivirus Software",
            "Endpoint Detection & Response (EDR) Software",
            "Endpoint Management Software",
            "Endpoint Protection Platforms Software",
            "Endpoint Protection Suites",
            "Identity Management Software",
            "Multi-Factor Authentication (MFA) Software",
            "Biometric Authentication Software",
            "Cloud Directory Services Software",
            "Customer Identity and Access Management (CIAM) Software",
            "Decentralized Identity Software",
            "Identity and Access Management (IAM) Software",
            "Passwordless Authentication Software",
            "Password Manager Software",
            "Password Policy Enforcement Software",
            "Privileged Access Management (PAM) Software",
            "Risk-Based Authentication Software",
            "Self-Service Password Reset (SSPR) Software",
            "Single Sign-On (SSO) Software",
            "User Provisioning and Governance Tools",
            "Network Security Software",
            "DNS Security Software",
            "Firewall Software",
            "Intrusion Detection and Prevention Systems (IDPS)",
            "Microsegmentation Software",
            "Network Access Control Software",
            "Network Detection and Response (NDR) Software",
            "Network Sandboxing Software",
            "Network Security Policy Management (NSPM) Software",
            "Network Traffic Analysis (NTA) Software",
            "Software-Defined Perimeter (SDP) Software",
            "Unified Threat Management Software",
            "Virtual Private Network (VPN) Software",
            "Zero Trust Networking Software",
            "Other IT Security Software",
            "Risk Assessment Software",
            "IT Risk Management Software",
            "Security Risk Analysis Software",
            "Vendor Security and Privacy Assessment Software",
            "User Threat Prevention Software",
            "Insider Threat Management (ITM) Software",
            "User and Entity Behavior Analytics (UEBA) Software",
            "Vulnerability Management Software",
            "Patch Management Software",
            "Risk-Based Vulnerability Management Software",
            "Secure Code Training Software",
            "Security Awareness Training Software",
            "Web Security Software",
            "Secure Web Gateways",
            "Bot Detection and Mitigation Software",
            "Browser Isolation Software",
            "Dark Web Monitoring Software",
            "DDoS Protection Software",
            "Fraud Detection Software",
            "Website Security Software",
            "SUPPLY CHAIN & LOGISTICS",
            "Demand Planning Software",
            "Distribution Software",
            "3PL Software",
            "Fleet Maintenance Software",
            "Fleet Management Software",
            "Fleet Tracking Software",
            "Freight Management Software",
            "Picking Software",
            "Route Planning Software",
            "Transportation Management Software",
            "Inventory Management Software",
            "Warehouse Management Software",
            "Barcode Software",
            "Inventory Control Software",
            "Label Printing Software",
            "Other Supply & Logistics Software",
            "Shipping Software",
            "Commodity Trading, Transaction, and Risk Management (CTRM) Software",
            "Cross Border E-Commerce Software",
            "Direct Store Delivery Software",
            "Global Trade Management Software",
            "Last Mile Delivery Software",
            "Multicarrier Parcel Management Solutions Software",
            "Sales & Ops Planning Software",
            "Supply Chain Management Software",
            "Supply Chain Suites Software",
            "Supplier Relationship Management Software",
            "Supply Chain Business Networks Software",
            "Supply Chain Cost-To-Serve Analytics Software",
            "Supply Chain Planning Software",
            "Supply Chain Visibility Software",
            "Yard Management Software",
            "HARDWARE ALL TYPES",
            "SERVERS",
            "Blade Servers",
            "Rack Servers",
            "Storage Servers",
            "Tower Servers",
            "ROUTERS",
            "Edge Routers",
            "Industrial Routers",
            "STORAGE  ",
            "All-Flash Arrays (AFA) Hardware",
            "Cloud Storage Hardware",
            "Network Attached Storage (NAS) Hardware",
            "SWITCHES",
            "Data Center Switches",
            "Fabric Interconnects",
            "LAN Switches",
            "SECURITY HARDWARE",
            "Advanced Threat Protection (ATP) Hardware",
            "Firewall Hardware",
          ],
        //  elementValue: ['SALES', 'CRM Software', 'Sales Compensation Software', 'AI Sales Assistant Software', 'Auto Dialer Software', 'Contract Analytics
          //  Software', 'Contract Lifecycle Management (CLM) Software', 'Contract Management Software', 'Customer Revenue Optimization Software', 'E-Signature Software', 'Field Sales Software', 'Other Sales Software', 'Partner Management Software', 'Quote Management Software', 'CPQ Software', 'Pricing Software', 'Proposal Software', 'Quote-to-Cash Software', 'Visual Configuration Software', 'Revenue Operations Software', 'Sales Acceleration Software', 'Conversation Intelligence Software', 'Digital Sales Room Software', 'Email Tracking Software', 'Lead-to-Account Matching and Routing Software', 'Outbound Call Tracking Software', 'Sales Coaching Software', 'Sales Enablement Software', 'Sales Engagement Software', 'Salesforce CRM Document Generation Software', 'Sales Performance Management Software', 'Sales Training and Onboarding Software', 'Sales Acceleration Platforms Software', 'Sales Analytics Software', 'Sales Gamification Software', 'Sales Intelligence Software', 'Sales Platforms Software', 'MARKETING', 'Account-Based Marketing Software', 'Account-Based Analytics Software', 'Account-Based Data Software', 'Buyer Intent Data Tools', 'Marketing Account Intelligence Software', 'Account-Based Execution Software', 'Account-Based Advertising Software', 'Account-Based Direct Mail Software', 'Account-Based Web and Content Experiences Software', 'Account-Based Orchestration Platforms Software', 'Account Data Management Software', 'Affiliate Marketing Software', 'App Store Optimization Software', 'Attribution Software', 'Audience Intelligence Platforms', 'B2B Services Review Platforms', 'Blogger Outreach Software', 'Book Marketing Tools Software', 'Competitive Intelligence Tools Software', 'Consumer Video Feedback Software', 'Content Marketing Software', 'Content Analytics Software', 'Content Creation Software', 'Content Curation Software', 'Content Distribution Software', 'Content Experience Platforms', 'Conversational Marketing Software', 'Conversion Rate Optimization Software', 'A/B Testing Software', 'Heat Maps Software', 'Landing Page Builders', 'Other Conversion Rate Optimization Software', 'Product Analytics Software', 'Session Replay Software', 'Customer Data Platform (CDP) Software', 'Customer Journey Analytics Software', 'Customer Journey Mapping Software', 'Customer-to-Customer (C2C) Community Marketing Software', 'Demand Generation Software', 'Brand Advocacy Software', 'Customer Advocacy Software', 'Employee Advocacy Software', 'Lead Generation Software', 'Lead Capture Software', 'Lead Intelligence Software', 'Lead Mining Software', 'Lead Scoring Software', 'Other Lead Generation Software', 'Visitor Identification Software', 'Loyalty Management Software', 'Digital Analytics Software', 'Digital Signage Software', 'Direct Mail Automation Software', 'Email Deliverability Software', 'Email Marketing Software', 'Email Signature Software', 'Email Template Builder Software', 'Email Testing Software', 'Event Management Software', ' Audience Response Software', 'Conference Intelligence Software', 'Event Management Platforms', 'Event Marketing Software'],
          elementSelectedValue: [],
          elementCustomSpecify: ''
        },
        {
          elementName:'chipsAutocomplete2',
          title:'Who is the key decision maker? *',
          elementValue:[],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'chipsAutocomplete3',
          title:'Who are the key influencers? Please name several if applicable.',
          elementValue:[],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'select1',
          title:'What is the estimated number of users/seats?',
          elementValue: ['Less than 10', '10 - 100','100-1000','Greater than 1000', 'Greater than 10000'],
          elementSelectedValue: [],
          elementCustomSpecify:''
        },
        {
          elementName:'select2',
          title:'How many people are involved in this project?',
          elementValue: ['1', '5', '10', '25','Other (describe)'],
          elementSelectedValue: [],
          elementCustomSpecify:'',
        },
        {
          elementName:'select3',
          title:'When is the deadline?',
          elementValue: ['3 Months', '3-6 Months', '6-9 Months', '9-12 Months','Next Year'],
          elementSelectedValue: [],
          elementCustomSpecify:'',
        },
        {
          elementName:'select4',
          title:'When will you be ready to start hearing from solution providers?',
          elementValue: ['3 Months', '3-6 Months', '6-9 Months', '9-12 Months','Next Year'],
          elementSelectedValue: [],
          elementCustomSpecify:'',
        },
        {
          elementName:'select5',
          title:'What is the estimated budget?',
          elementValue:['5-25K','25-50K','50-100K','100-250K','250-500k','500K-1MM','More than 1MM'],
          elementSelectedValue: [],
          elementCustomSpecify:'',
        },
        {
          elementName:'inputText1',
          title:'Who is your existing provider?',
          elementValue:[],
          elementSelectedValue: [],
          elementCustomSpecify:'',
        },
        {
          elementName:'inputText2',
          title:'Do you have any preferred vendors that you are considering?',
          elementValue:[],
          elementSelectedValue: [],
          elementCustomSpecify:'',
        }
      ]
    }

  }

  ngOnInit(): void {

    if(this.surveyId != null){
      this.loadSurvey(this.surveyId);
    }

    this.formGroup1 = this._formBuilder.group({
      radioGroup1: [this.findQuestions('radioGroup1').elementSelectedValue[0], Validators.required],
      radioGroup2: [this.findQuestions('radioGroup2').elementSelectedValue[0], Validators.required],
      radioGroup3: [this.findQuestions('radioGroup3').elementSelectedValue[0]]
    });
    this.formGroup1.get('radioGroup1').valueChanges.subscribe(data=> {
      this.findQuestions('radioGroup1').elementSelectedValue=[]
      this.findQuestions('radioGroup1').elementSelectedValue.push(data)
    });
    this.formGroup1.get('radioGroup2').valueChanges.subscribe(data=> {
      this.findQuestions('radioGroup2').elementSelectedValue=[];
      this.findQuestions('radioGroup2').elementSelectedValue.push(data)
    });
    this.formGroup1.get('radioGroup3').valueChanges.subscribe(data=> {
      this.findQuestions('radioGroup3').elementSelectedValue=[];
      this.findQuestions('radioGroup3').elementSelectedValue.push(data);
    });

    this.formGroup2 = this._formBuilder.group({
      autocomplete1:[this.findQuestions('chipsAutocomplete1').elementSelectedValue,this.validateChips],
      radioGroup4 :[''],
      inputText2:['']
    });
    this.formGroup2.get('radioGroup4').valueChanges.subscribe(data=> {
      this.findQuestions('radioGroup4').elementSelectedValue=[];
      this.findQuestions('radioGroup4').elementSelectedValue.push(data);
    });
    this.formGroup2.get('inputText2').valueChanges.subscribe(data=> {
      this.findQuestions('inputText2').elementSelectedValue = [];
      this.findQuestions('inputText2').elementSelectedValue.push(data);
    });
    this.formGroup2.get('autocomplete1').valueChanges.subscribe(data=> {
      this.findQuestions('chipsAutocomplete1').elementSelectedValue = data
    });

    this.formGroup3 = this._formBuilder.group({
      radioGroup5 :[''],
      select3:[''],
      select4:['']
    });
    this.formGroup3.get('radioGroup5').valueChanges.subscribe(data=> {
      this.findQuestions('radioGroup5').elementSelectedValue = [];
      this.findQuestions('radioGroup5').elementSelectedValue.push(data);
    });
    this.formGroup3.get('select3').valueChanges.subscribe(data=> {
      this.findQuestions('select3').elementSelectedValue=[];
      this.findQuestions('select3').elementSelectedValue.push(data);
    });
    this.formGroup3.get('select4').valueChanges.subscribe(data=> {
      this.findQuestions('select4').elementSelectedValue=[];
      this.findQuestions('select4').elementSelectedValue.push(data);
    });

    this.formGroup4 = this._formBuilder.group({
      radioGroup7:[''],
      select1:[''],

    });
    this.formGroup4.get('radioGroup7').valueChanges.subscribe(data=> {
      this.findQuestions('radioGroup7').elementSelectedValue = [];
      this.findQuestions('radioGroup7').elementSelectedValue.push(data);
    });
    this.formGroup4.get('select1').valueChanges.subscribe(data=> {
      this.findQuestions('select1').elementSelectedValue = [];
      this.findQuestions('select1').elementSelectedValue.push(data);
    });

    this.formGroup5 = this._formBuilder.group({
      select2:[''],
      autocomplete2:[this.findQuestions('chipsAutocomplete2').elementSelectedValue,this.validateChips],
      autocomplete3:[this.findQuestions('chipsAutocomplete3').elementSelectedValue],
    });
    this.formGroup5.get('select2').valueChanges.subscribe(data=> {
      this.findQuestions('select2').elementSelectedValue =[];
      this.findQuestions('select2').elementSelectedValue.push(data);
    });
    this.formGroup5.get('autocomplete2').valueChanges.subscribe(data=> this.findQuestions('chipsAutocomplete2').elementSelectedValue = data);
    this.formGroup5.get('autocomplete3').valueChanges.subscribe(data=> this.findQuestions('chipsAutocomplete3').elementSelectedValue = data);

    this.formGroup6 =this._formBuilder.group({
      inputText1:[''],
      radioGroup6:['']
    });
    this.formGroup6.get('inputText1').valueChanges.subscribe(data=> {
      this.findQuestions('inputText1').elementSelectedValue = [];
      this.findQuestions('inputText1').elementSelectedValue.push(data);
    });
    this.formGroup6.get('radioGroup6').valueChanges.subscribe(data=> {
      this.findQuestions('radioGroup6').elementSelectedValue = [];
      this.findQuestions('radioGroup6').elementSelectedValue.push(data);
    });

    //this.loadContacts();
    this.findContacts('');
    this.findContactsMaker('');
    this.category = this.findQuestions('chipsAutocomplete1')
      .elementValue
      .map(x=><KeyValuePair>{key:x, value:x,});


  }

  public goBack(stepper: MatStepper) {
    stepper.previous();
  }

  public goForward(stepper: MatStepper) {

    switch (stepper.selectedIndex) {
      case 0:
        this.formGroup1.markAllAsTouched();
        break;
    }
    stepper.next();
  }

  public onRadioGroup1ItemChange(value) {
    if (value == "Please specify") {
      this.formGroup1.addControl("customSpecify", new FormControl('',Validators.required));
      this.formGroup1.get('customSpecify').valueChanges.subscribe(data=> this.findQuestions('radioGroup1').elementCustomSpecify = data);
      this.isVisibleCustomSpecify = true;
    }
    else{
      this.formGroup1.removeControl('customSpecify');
      this.isVisibleCustomSpecify = false;
    }
  }

  public onRadioGroup3ItemChange(value) {
    this.isVisibleStep2 = value == "Considering replacing an existing solution" || value == "Definitely replacing an existing solution";
  }

  public onRadioGroup7ItemChange(value) {
    if (value == "Yes") {
      this.formGroup4.addControl("select5", new FormControl('',Validators.required));
      this.formGroup4.get('select5').valueChanges.subscribe(data=> {
        this.findQuestions('select5').elementSelectedValue=[];
        this.findQuestions('select5').elementSelectedValue.push(data);
      });
    }
    else{
      this.formGroup4.removeControl('select5');
    }
  }

  public onRadioGroup6ItemChange(value) {
    if(value=="Other (describe)") {
      this.formGroup6.addControl("other", new FormControl('',Validators.required));
      this.formGroup6.get('other').valueChanges.subscribe(data=> this.findQuestions('radioGroup6').elementCustomSpecify = data);
      this.isVisibleOther = true;
    }
    else{
      this.formGroup6.removeControl( 'other');
      this.isVisibleOther = false;
    }
  }

  public onSelect2ItemChange(value) {
    if(value=="Other (describe)") {
      this.formGroup5.addControl("teamSpecify", new FormControl('',Validators.required));
      this.formGroup5.get('teamSpecify').valueChanges.subscribe(data=> this.findQuestions('select2').elementCustomSpecify = data);
    }
    else{
      this.formGroup5.removeControl( 'teamSpecify');
    }
  }

  public findQuestions(elementName:string){
    return this.surveyModel.questions.find(x=>x.elementName == elementName)
  }

  public finishSurvey(){
    if(this.formGroup1.valid || this.formGroup2.valid || this.formGroup3.valid || this.formGroup4.valid || this.formGroup5.valid || this.formGroup6.valid)
    this.dialogRef.close(this.surveyModelToSurveyDto());
  }

  public closeDialog(){
    this.dialogRef.close();
  }

  public findContacts(searchQuery:string){
    const body: ContactPageRequestDto = {
      pageNumber: 0,
      pageSize: 50,
      filters: {
        filterType: GlobalSearchResultTypeEnum.CONTACT,
        companyId:[this.companyId],
        search:searchQuery,
      },
    };

    this.contactService.findContacts({ body }).subscribe(res=>{
      this.contacts = res.content.map(x=> <KeyValuePair>{key:x.id, value:x.name+ " - " +x.title})
    });
  }

  public findContactsMaker(searchQuery:string){
    const body: ContactPageRequestDto = {
      pageNumber: 0,
      pageSize: 50,
      filters: {
        filterType: GlobalSearchResultTypeEnum.CONTACT,
        companyId:[this.companyId],
        search:searchQuery,
      },
    };

    this.contactService.findContacts({ body }).subscribe(res=>{
     this.contactsMaker = res.content.map(x=> <KeyValuePair>{key:x.id, value:x.name+ " - " +x.title})
   });
  }

  private validateChips(chips: FormControl) {
    if (chips.value && chips.value.length === 0) {
      return {
        validateChipsArray: { valid: false }
      };
    }
    return null;
  }

  private loadSurvey(id){
      this.surveyService.getSurvey({id:id}).subscribe((data)=>{
        this.surveyDto = data;
        this.setDataToFormGroup1(this.surveyDto);
        this.setDataToFormGroup2(this.surveyDto);
        this.setDataToFormGroup3(this.surveyDto);
        this.setDataToFormGroup4(this.surveyDto);
        this.setDataToFormGroup5(this.surveyDto);
        this.setDataToFormGroup6(this.surveyDto);

      });

  }

  private surveyModelToSurveyDto(){

    let surveyDto:SurveyDto = {
      surveyId:this.surveyId,
      hardwareAmount:0,// ??
      projectName:'',// ??
      userId:'',
      userIsOwner:true,
      companyId :this.companyId,
      budget: this.getBudgetLimitToBudgetLimitEnumItem(this.findQuestions('select5').elementSelectedValue[0]),
      deadline:this.getPeriodEnumItem(this.findQuestions('select3').elementSelectedValue[0]),
      department:(this.findQuestions('radioGroup1').elementSelectedValue[0]=='Please specify')
        ?this.findQuestions('radioGroup1').elementCustomSpecify
        :this.findQuestions('radioGroup1').elementSelectedValue[0],
      departmentMembershipType:(this.findQuestions('radioGroup2').elementSelectedValue[0] == 'Yes')
        ?SurveyMembershipTypeEnum.MEMBERSHIP_YES
        :(this.findQuestions('radioGroup2').elementSelectedValue[0]=='No')
          ?SurveyMembershipTypeEnum.MEMBERSHIP_NO
          :null,
      existingVendor:this.findQuestions('inputText1').elementSelectedValue[0],
      preferredVendors:this.findQuestions('inputText2').elementSelectedValue,//need check
      productCategory:this.findQuestions('chipsAutocomplete1').elementSelectedValue.map(x=>x.value),
      satisfactionLevel:(this.findQuestions('radioGroup6').elementSelectedValue[0]=='Other (describe)')
        ?this.findQuestions('radioGroup6').elementCustomSpecify
        :this.findQuestions('radioGroup6').elementSelectedValue[0],
      seatsAmount:this.getSeatsAmountEnumItem(this.findQuestions('select1').elementSelectedValue[0]),
      solutionAim:this.getSolutionAimEnumItem(this.findQuestions('radioGroup3').elementSelectedValue[0]),
      solutionType:this.findQuestions('radioGroup4').elementSelectedValue[0],
      solutionsProposalLimit:this.getPeriodEnumItem(this.findQuestions('select4').elementSelectedValue[0]),
      teamDecisionMaker: this.setTeamDecisionMaker(this.findQuestions('chipsAutocomplete2').elementSelectedValue),
      teamKeyInfluencers: this.findQuestions('chipsAutocomplete3').elementSelectedValue.map(x=><PersonReferenceDto>{personId:x.key,personName:x.value}),//need fix api
      teamSize: (this.findQuestions('select2').elementSelectedValue[0]=='Other (describe)')
        ?this.findQuestions('select2').elementCustomSpecify
        :this.findQuestions('select2').elementSelectedValue[0],
    }
    return surveyDto;
  }

  private setTeamDecisionMaker(value:KeyValuePair[]):PersonReferenceDto{
    if(value[0].key === '0'){
      return value.map(x=><PersonReferenceDto>{personName:x.value})[0];
    }
    return value.map(x=><PersonReferenceDto>{personId:x.key,personName:x.value})[0];
  }

  private setTeamKeyInfluencers(value:KeyValuePair[]):PersonReferenceDto[]{
    return value.map(obj=>{
      if(obj.key=='0'){
        return <PersonReferenceDto>{personName:obj.value}
      }else{
        return<PersonReferenceDto>{personId:obj.key,personName:obj.value}
      }
    });
  }

  private setDataToFormGroup1(surveyDto:SurveyDto){

    if(this.findQuestions('radioGroup1').elementValue.indexOf(surveyDto.department)  == -1) {
      this.onRadioGroup1ItemChange('Please specify')
      this.formGroup1.setValue({
        radioGroup1: 'Please specify',
        radioGroup2: (surveyDto.departmentMembershipType == SurveyMembershipTypeEnum.MEMBERSHIP_YES) ? 'Yes' : 'No',
        radioGroup3: this.getTextFromSolutionAimEnumItem(surveyDto.solutionAim),
        customSpecify: surveyDto.department
      })
    }else{
      this.formGroup1.setValue({
        radioGroup1: surveyDto.department,
        radioGroup2: (surveyDto.departmentMembershipType == SurveyMembershipTypeEnum.MEMBERSHIP_YES) ? 'Yes' : 'No',
        radioGroup3: this.getTextFromSolutionAimEnumItem(surveyDto.solutionAim),
      })
    }

    if(surveyDto.solutionAim == SolutionAimEnum.AIM_REPLACE_EXISTING || surveyDto.solutionAim == SolutionAimEnum.AIM_CONSIDER_REPLACE_EXISTING){
      this.onRadioGroup3ItemChange('Considering replacing an existing solution');
    }
  }
  private setDataToFormGroup2(surveyDto:SurveyDto){
    this.formGroup2.setValue({
      autocomplete1: [],
      radioGroup4:surveyDto.solutionType,
      inputText2:surveyDto.preferredVendors.toString()
    });
    this.startSelectedValuesAutocomplete1 =  surveyDto.productCategory.map(x=><KeyValuePair>{key:x, value:x}); //[{key:surveyDto.productCategory,value:surveyDto.productCategory}];
  }
  private setDataToFormGroup3(surveyDto:SurveyDto){
    this.formGroup3.setValue({
      radioGroup5:(surveyDto.deadline != null||surveyDto.solutionsProposalLimit != null)?'Yes':'No',
      select3:this.getTextFromPeriodEnumItem(surveyDto.deadline),
      select4:this.getTextFromPeriodEnumItem(surveyDto.solutionsProposalLimit),
    });
  }
  private setDataToFormGroup4(surveyDto:SurveyDto){

   if(surveyDto.budget != null){
     this.onRadioGroup7ItemChange('Yes')
     this.formGroup4.setValue({
       select1:this.getTextFromSeatsAmountEnumItem(surveyDto.seatsAmount),
       select5:this.getTextFromBudgetLimitToBudgetLimitEnumItem(surveyDto.budget),
       radioGroup7:(surveyDto.budget != null)?'Yes':'No',
     });
   }else{
     this.formGroup4.setValue({
       select1:this.getTextFromSeatsAmountEnumItem(surveyDto.seatsAmount),
       radioGroup7:(surveyDto.budget != null)?'Yes':'No',
     })
   }

  }
  private setDataToFormGroup5(surveyDto:SurveyDto){

    if(this.findQuestions('select2').elementValue.indexOf(surveyDto.teamSize)  == -1){
      this.onSelect2ItemChange('Other (describe)');
      this.formGroup5.setValue({
        select2:'Other (describe)',
        teamSpecify:surveyDto.teamSize,
        autocomplete2:[],
        autocomplete3:[],
      })
    }else{
      this.formGroup5.setValue({
        select2:surveyDto.teamSize,
        autocomplete2:[],
        autocomplete3:[],
      })
    }
    this.startSelectedValuesAutocomplete2 = [{key:surveyDto.teamDecisionMaker.personId,value:surveyDto.teamDecisionMaker.personName}];
    this.startSelectedValuesAutocomplete3 = surveyDto.teamKeyInfluencers.map(x=><KeyValuePair>{key:x.personId, value:x.personName});
  }
  private setDataToFormGroup6(surveyDto:SurveyDto){
    if(surveyDto.satisfactionLevel != 'Other (describe)'){
      this.formGroup6.setValue({
        inputText1:surveyDto.existingVendor,
        radioGroup6:surveyDto.satisfactionLevel
      })
    }else{
      this.formGroup6.setValue({
        inputText1:surveyDto.existingVendor,
        radioGroup6:'Other (describe)',
        other:surveyDto.satisfactionLevel
      })
      this.onRadioGroup6ItemChange('Other (describe)')
    }

  }

  private getSeatsAmountEnumItem(value:string) {
    switch (value) {
      case 'Less than 10':
        return SeatsAmountEnum.LESS_THAN_10;
      case '10 - 100':
        return SeatsAmountEnum.FROM_10_TO_100;
      case '100-1000':
        return SeatsAmountEnum.FROM_100_TO_1000;
      case 'Greater than 1000':
        return SeatsAmountEnum.FROM_1000_TO_10000
      case 'Greater than 10000':
        return SeatsAmountEnum.MORE_THAN_10000;
      default:
        return null
    }
  }

  private getBudgetLimitToBudgetLimitEnumItem(value:string){
    switch (value) {
      case '5-25K':
        return BudgetLimitEnum.FROM_5_TO_25_K;
      case '25-50K':
        return BudgetLimitEnum.FROM_25_TO_50_K;
      case '50-100K':
        return BudgetLimitEnum.FROM_50_TO_100_K;
      case '100-250K':
        return BudgetLimitEnum.FROM_100_TO_250_K;
      case '250-500k':
        return BudgetLimitEnum.FROM_100_TO_250_K;
      case '500K-1MM':
        return BudgetLimitEnum.FROM_100_TO_250_K;
      case 'More than 1MM':
        return BudgetLimitEnum.FROM_100_TO_250_K;
      default:
        return null
        break;
    }
  }

  private getPeriodEnumItem(value:string){
    switch (value) {
      case '3 Months':
        return PeriodEnum.MONTH_3;
      case '3-6 Months':
        return PeriodEnum.MONTH_3_6;
      case '6-9 Months':
        return PeriodEnum.MONTH_6_9;
      case '9-12 Months':
        return PeriodEnum.MONTH_9_12;
      case 'Next Year':
        return PeriodEnum.NEXT_YEAR;
      default:
        return null
        break;
    }
  }

  private getSolutionAimEnumItem(value:string){
    switch (value) {
      case 'First time buying this product or service':
        return SolutionAimEnum.AIM_FIRST_TIME_BUYING;
      case 'Definitely replacing an existing solution':
        return SolutionAimEnum.AIM_REPLACE_EXISTING;
      case 'Considering replacing an existing solution':
        return SolutionAimEnum.AIM_CONSIDER_REPLACE_EXISTING
      default:
        return null
        break;
    }
  }


  private getTextFromSeatsAmountEnumItem(value:string) {
    switch (value) {
      case SeatsAmountEnum.LESS_THAN_10:
        return 'Less than 10';
      case SeatsAmountEnum.FROM_10_TO_100:
        return '10 - 100';
      case SeatsAmountEnum.FROM_100_TO_1000:
        return '100-1000';
      case SeatsAmountEnum.FROM_1000_TO_10000:
        return 'Greater than 1000';
      case SeatsAmountEnum.MORE_THAN_10000:
        return 'Greater than 10000';
      default:
        return null
    }
  }

  private getTextFromBudgetLimitToBudgetLimitEnumItem(value:string){
    switch (value) {
      case BudgetLimitEnum.FROM_5_TO_25_K:
        return '5-25K';
      case BudgetLimitEnum.FROM_25_TO_50_K:
        return '25-50K';
      case BudgetLimitEnum.FROM_50_TO_100_K:
        return '50-100K';
      case BudgetLimitEnum.FROM_100_TO_250_K:
        return '100-250K';
      case BudgetLimitEnum.FROM_100_TO_250_K:
        return '250-500k';
      case BudgetLimitEnum.FROM_100_TO_250_K:
        return '500K-1MM';
      case BudgetLimitEnum.FROM_100_TO_250_K:
        return 'More than 1MM';
      default:
        return null
        break;
    }
  }

  private getTextFromPeriodEnumItem(value:string){
    switch (value) {
      case PeriodEnum.MONTH_3:
        return '3 Months';
      case PeriodEnum.MONTH_3_6:
        return '3-6 Months';
      case PeriodEnum.MONTH_6_9:
        return '6-9 Months';
      case PeriodEnum.MONTH_9_12:
        return '9-12 Months';
      case PeriodEnum.NEXT_YEAR:
        return 'Next Year';
      default:
        return null
        break;
    }
  }

  private getTextFromSolutionAimEnumItem(value:string){
    switch (value) {
      case SolutionAimEnum.AIM_FIRST_TIME_BUYING:
        return 'First time buying this product or service';
      case SolutionAimEnum.AIM_REPLACE_EXISTING:
        return 'Definitely replacing an existing solution';
      case SolutionAimEnum.AIM_CONSIDER_REPLACE_EXISTING:
        return 'Considering replacing an existing solution';
      default:
        return null
        break;
    }
  }

}
